<template>
    <div class="amchart" ref="chartdiv">
    </div>
</template>

<script>
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import am5locales_zh_Hant from "@amcharts/amcharts5/locales/zh_Hant";

am5.addLicense("AM5C61615");
am5.addLicense("AM5M61615");
am5.addLicense("AM5S61615");

export default {
name: 'strat_grid_amchart',
data() {
    return {
        updating_chart_data: [],    // updated chart data passed in
        benname:'基准',
    }
},
props: {
    // 从父组件传入的值们
    chart_data: {
        type: Array,
        default() {
            []
        }
    },
    ben_name:{
        type: String,
        default() {
            '基准'
        }
    }
},
watch: {
    chart_data: {
        // watch if there is change in props and update the chart in time
        handler(val) {
            if (val) {
                this.updating_chart_data = val;
                
                if (this.root) {
                  this.updateChartdata();
                }
            }
        },
        deep: true,
        immediate: true,
    },
    ben_name:{
        handler(val) {
            if (val) {
                this.benname = val;
            }
        },
        deep: true,
        immediate: true,        
    }
},
methods: {
    initChart(root) {
        /**
         * Initialize amchart with desired setting and initial data.
         */

        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        const chart = root.container.children.push(am5xy.XYChart.new(root, {
            focusable: true,    // Focusable elements in charts can be selected using TAB key.
            layout: root.verticalLayout,
            maxTooltipDistance: -1,
        })); 

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        const xAxis = chart.xAxes.push(am5xy.GaplessDateAxis.new(root, {
            maxDeviation: 0.0,
            groupData: false,
            baseInterval: {
                timeUnit: "day",
                count: 1
            },
            forceHidden: true,  // hide axis labels
            renderer: am5xy.AxisRendererX.new(root, {}),
        }));
        xAxis.get("renderer").grid.template.set("strokeOpacity", 0);    // hide the grid
        xAxis.get("renderer").grid.template.set("location", 1);    

        const yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            extraMin: 0.05,
            extraMax: 0.05, 
            strictMinMax: true,
            forceHidden: true,  // hide axis labels
            renderer: am5xy.AxisRendererY.new(root, {})
        }));
        yAxis.get("renderer").grid.template.set("strokeOpacity", 0);    // hide the grid

        // Add series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        const series = chart.series.push(am5xy.LineSeries.new(root, {
            name: "策略", //收益率
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "value",
            valueXField: "date",
            tooltip: am5.Tooltip.new(root, {
                pointerOrientation: "horizontal",
                labelText: "策略:"+"{valueY}"+"%"
            })
        }));
        series.strokes.template.setAll({
            strokeWidth: 2
        });
        // set tooltip when cursor is near 策略
        var tooltip = series.set("tooltip", am5.Tooltip.new(root, {
            getFillFromSprite: false,
            getStrokeFromSprite: true,
            autoTextColor: false,
            pointerOrientation: "horizontal"
        }));
        tooltip.get("background").setAll({
            fill: am5.color(0xffffff),
            fillOpacity: 0.9
        })
        tooltip.label.setAll({
            text: "[bold]{valueX}[/]",
            fill: am5.color(0x000000)
        });
        tooltip.label.adapters.add("text", function(text, target) {
            chart.series.each(function (series) {
                text += '\n[' + series.get("stroke").toString() + ']●[/] [bold width:100px]' + series.get("name") + ': {' + series.get("valueYField") + '}%'
            })
            return text
        })

        // Set up data processor to parse string dates
        // https://www.amcharts.com/docs/v5/concepts/data/#Pre_processing_data
        series.data.processor = am5.DataProcessor.new(root, {
            dateFormat: "yyyy-MM-dd",
            dateFields: ["date"]
        });

        // Add series2
        const series2 = chart.series.push(am5xy.LineSeries.new(root, {
            name: this.benname, //"基准" 收益率
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "bench_value",
            valueXField: "date"    
        }));
        // set the color of the strokes to dark red
        series2.set("stroke", am5.color("#e60000"));
        series2.strokes.template.setAll({
            strokeWidth: 2
        });
        // set tooltip when cursor is near 基准
        var tooltip = series2.set("tooltip", am5.Tooltip.new(root, {
            getFillFromSprite: false,
            getStrokeFromSprite: false,
            autoTextColor: false,
            pointerOrientation: "horizontal"
        }));
        tooltip.get("background").setAll({
            stroke: am5.color(0xe60000),
            fill: am5.color(0xffffff),
            fillOpacity: 0.9
        })
        tooltip.label.setAll({
            text: "[bold]{valueX}[/]",
            fill: am5.color(0x000000)
        });
        tooltip.label.adapters.add("text", function(text, target) {
            chart.series.each(function (series) {
                text += '\n[' + series.get("stroke").toString() + ']●[/] [bold width:100px]' + series.get("name") + ': {' + series.get("valueYField") + '}%'
            })
            return text
        })

        // Load data
        series.data.setAll(this.updating_chart_data);
        series2.data.setAll(this.updating_chart_data);

        // Add cursor
        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
        const cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
            xAxis: xAxis,
            behavior: "none"
        }));
        cursor.lineY.set("visible", false);

        let legend = chart.children.unshift(am5.Legend.new(root, {
            nameField: "name",
            centerX: am5.percent(50),
            x: am5.percent(80),
            y: 5,
        }));
        legend.data.setAll(chart.series.values);
        legend.labels.template.setAll({
            fontSize: 12,
        });
        legend.valueLabels.template.set("forceHidden", true)

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        chart.appear(1000, 100); 
        this.root = root;
        this.series = series;
        this.series2 = series2;
    },

    updateChartdata(){
        // updating chart with new data
        this.series.data.setAll(this.updating_chart_data);
        this.series2.data.setAll(this.updating_chart_data);
    }
},
mounted() {
    let root = am5.Root.new(this.$refs.chartdiv);
    
    root.utc = true;
    root.locale = am5locales_zh_Hant;

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
        am5themes_Animated.new(root)
    ]);

    root.dateFormatter.setAll({
        dateFormat: "yyyy-MM-dd",
        dateFields: ["valueX"]
    });

    this.initChart(root);
},
beforeDestroy() {
    if (this.root) {
        this.root.dispose();
    }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.amchart {
    width: 350px;
    height: 230px;
}
</style>